import Blog_50_2_container from "./container/Blog_50_2_container";
export default Blog_50_2_container;
